export class RichText {
  constructor(text: string) {
    this.text = text;
  }

  text: string;
  appendLinebreak?: boolean;
  fontSize?: string;
  color?: string;
  bold?: boolean;
  italic?: boolean;
  strikethrough?: boolean;
  underline?: boolean;
}
